import AsyncStorage from "@react-native-async-storage/async-storage";

const KEY = "@utilities/recent_products";
const MAX = 5;

export interface RecentProduct {
  id: string;
  name: string;
  stockNumber: string;
}

export async function loadRecentProducts(): Promise<RecentProduct[]> {
  try {
    const raw = await AsyncStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export async function saveRecentProduct(product: RecentProduct): Promise<void> {
  try {
    const existing = await loadRecentProducts();
    const deduped = existing.filter((p) => p.id !== product.id);
    const updated = [product, ...deduped].slice(0, MAX);
    await AsyncStorage.setItem(KEY, JSON.stringify(updated));
  } catch {
    // ignore storage errors silently
  }
}
